export const VERTICAL_NAME = 'VISITOR_REGISTRATION';
